module.exports = __webpack_public_path__ + "themify.eot?2c454669bdf3aebf32a1bd8ac1e0d2d6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/themify.eot?-fvbane
// module id = 922
// module chunks = 27